module.exports = __webpack_public_path__ + "static/mobilebanner-7905180ac93069684f16c74f9052244e.webp";